// @flow

// Vendors
import React from 'react';

// Types
type Props = {
  bids: Array<{
    link: string,
    title: string,
    city: string,
    state: string,
    bidDueDate: string
  }>,
  rowLabels: {
    projectName: string,
    location: string,
    dueDate: string
  }
};

const SmartBidBidsTable = ({ bids, rowLabels }: Props) => (
  <table className="table table--striped smartbids-results__table">
    <thead>
      <tr>
        <th className="smartbids-results__table__name">
          {rowLabels.projectName}
        </th>
        <th className="smartbids-results__table__location">
          {rowLabels.location}
        </th>
        <th className="smartbids-results__table__due-date">
          {rowLabels.dueDate}
        </th>
      </tr>
    </thead>
    <tbody>
      {bids.map(({ link, title, city, state, bidDueDate }) => (
        <tr key={link}>
          <td>
            <a
              href={`https://secure.smartinsight.co/#/PublicBidProject/${link}`}
              target="_blank"
            >
              {title}
            </a>
          </td>
          <td>
            {city}, {state}
          </td>
          <td>{bidDueDate}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

SmartBidBidsTable.defaultProps = {
  rowLabels: {
    projectName: 'Project Name',
    location: 'Location',
    dueDate: 'Due Date'
  }
};

export default SmartBidBidsTable;
